import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { t } from 'i18next';
import { useContext, useRef } from 'react';

import CheckableMenuItem from '~components/Menu/CheckableMenuItem';
import Menu, { MenuHandler } from '~components/Menu/Menu';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

import ApproveChargesPageContext from '../ApproveChargesPageContext';
import { CHARGES_GROUP_BY_OPTIONS, ChargesGroupBy } from '../chargesGrouping';

const groupByLabelKeys = {
  [ChargesGroupBy.CUSTOMER]: 'common.customer',
  [ChargesGroupBy.NONE]: 'common.none',
  [ChargesGroupBy.PAYEE]: 'approvals.approve_charges.group_by.payee',
  [ChargesGroupBy.PROJECT]: 'common.project',
} satisfies Record<ChargesGroupBy, string>;

export default function ChargesGroupMenu() {
  const { groupBy, setGroupBy } = useContext(ApproveChargesPageContext);
  const menu = useRef<MenuHandler>(null);

  return (
    <Menu
      ref={menu}
      menuTrigger={
        <SmallButton color="inherit" endIcon={<ArrowDropDown />} variant="outlined">
          {t('approvals.approve_charges.group', {
            value: t(groupByLabelKeys[groupBy]),
          })}
        </SmallButton>
      }
    >
      {CHARGES_GROUP_BY_OPTIONS.map((option) => (
        <CheckableMenuItem
          key={option}
          isChecked={option === groupBy}
          label={t(groupByLabelKeys[option])}
          onClick={() => {
            setGroupBy(option);
            menu.current?.onClose?.();
          }}
        />
      ))}
    </Menu>
  );
}
